<template>
  <div class="tutorial-container">
    <h1 id="top-title">Wie es funktioniert</h1>
    <div class="content-tutorial">
      <h3>Easy!</h3>
      <p class="subtitle">
        Dein rechtssicheres Dokument in 3 einfachen Schritten
      </p>
      <ul>
        <li>
          <strong>Schritt 1:</strong> Wähle, welches Dokument du benötigst (AGB,
          Impressum, Datenschutzerklärung).
        </li>
        <li>
          <strong>Schritt 2:</strong> Beantworte einige einfache Fragen zu
          deinem Unternehmen.
        </li>
        <li>
          <strong>Schritt 3:</strong> Erhalte dein individuell erstelltes
          Dokument – sofort einsatzbereit!
        </li>
      </ul>
      <p class="more-info">
        Mit unserem einfachen und intuitiven Prozess sparst du Zeit und Aufwand.
        Unsere Experten haben alle rechtlichen Aspekte berücksichtigt, damit du
        dich auf dein Kerngeschäft konzentrieren kannst.
      </p>
    </div>
  </div>
</template>

<style scoped>
.tutorial-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px 20px;
  min-height: 100vh;
  margin-top: 150px;
}

.content-tutorial {
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
  padding: 30px 40px;
  max-width: 600px;
  width: 100%;
}

#top-title {
  color: #333;
  margin-bottom: 80px;
  font-size: 30px;
}

h3 {
  font-size: 28px;
  margin-bottom: 10px;
  text-align: center;
}

.subtitle {
  display: block;
  font-size: 18px;
  color: #666;
  text-align: center;
  margin-bottom: 20px;
}

ul {
  list-style: none;
  padding: 0;
  margin: 20px 0;
}

li {
  background: #e6e6e6;
  margin-bottom: 15px;
  padding: 15px 20px;
  border-radius: 8px;
  font-size: 16px;
  line-height: 1.5;
  text-align: left;
}

.more-info {
  font-size: 16px;
  color: #555;
  text-align: center;
  margin-top: 55px;
  line-height: 1.6;
}
</style>
